"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteService = void 0;
var _site = require("../controllers/site.controller");
var SiteService = {
  site: {
    add: _site.config.site,
    edit: _site.config.site + "/edit",
    read: _site.config.site,
    change: _site.config.site + "/edit/brand/change",
    update: _site.config.site + "/fund",
    list: _site.config.site + "/list",
    submit: _site.config.site + "/submit",
    approve: _site.config.site + "/approve",
    delete: _site.config.site,
    clone: _site.config.site + "/clone",
    save: _site.config.site + "/save",
    buildList: _site.config.site + "/list/build",
    // api is not ready for below
    filter: _site.config.site,
    pause: _site.config.site + "/pause",
    play: _site.config.site + "/resume",
    copyUrl: _site.config.site,
    downloadEmail: _site.config.site,
    restricted: _site.config.site + "/restricted",
    unrestricted: _site.config.site + "/unrestricted",
    locked: _site.config.site + "/bulk/lock",
    unlocked: _site.config.site + "/bulk/unlock",
    viewSnapshots: _site.config.site,
    viewEditorList: _site.config.site,
    viewConfig: _site.config.site,
    softDelete: _site.config.site + "/delete/soft",
    softDeleteList: _site.config.site + "/list/soft/deleted",
    softDeleteRestore: _site.config.site + "/delete/soft/restore"
  },
  siteBulk: {
    submit: _site.config.siteBulk + "/submit",
    approve: _site.config.siteBulk + "/approve",
    bulkDeleted: _site.config.siteBulk + "/delete",
    bulkAdd: _site.config.siteBulk,
    bulkGoLive: _site.config.siteBulk,
    bulkPlay: _site.config.siteBulk + "/resume",
    bulkPause: _site.config.siteBulk + "/pause",
    bulkAlertOn: _site.config.siteBulk + "/alert/on",
    bulkAlertOff: _site.config.siteBulk + "/alert/off",
    bulkRestricted: _site.config.siteBulk + "/restricted",
    bulkUnrestricted: _site.config.siteBulk + "/unrestricted",
    bulkLocked: _site.config.siteBulk + "/lock",
    bulkUnlocked: _site.config.siteBulk + "/unlock",
    bulkClone: _site.config.siteBulk + "/clone",
    bulkSoftDeleteSite: _site.config.siteBulk + "/delete/soft",
    bulkSoftDeleteRestore: _site.config.siteBulk + "/delete/soft/restore"
  },
  siteEditor: {
    editSite: _site.config.siteEditor,
    findSite: _site.config.siteEditor + "/list",
    deleteSite: _site.config.siteEditor + "/delete",
    changeBrand: _site.config.siteEditor + "/brand/change",
    editRecord: _site.config.site,
    lock: _site.config.siteEditor + "/lock",
    unlock: _site.config.siteEditor + "/unlock"
  },
  siteEdit: {
    root: _site.config.siteEdit,
    changeBrand: _site.config.siteEdit + "/brand/change"
  },
  siteRendering: {
    rendering: _site.config.site + "/render"
  }
};
exports.SiteService = SiteService;